import styled from 'styled-components';
import { SwitchInput, Button } from '@thinknet-gmbh/platform-common-ui';

export const ConfirmSwitchInput = styled(SwitchInput)`
  margin-left: 5px;
`;

export const BackToPoolButton = styled(Button)`
  button {
    color: ${({ theme }) => theme.colors.primary.blue};
  }
`;

export const ActionIconWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.grayVariations.shadow};
  height: 30px;
  width: 30px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }
`;
